import { Component, OnInit } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';

import { TestimonialQuoteType } from "../testimonial-quote.type";

@Component({
    selector: 'app-talkers',
    templateUrl: './talkers.component.html',
    styleUrls: ['./talkers.component.scss']
})

export class TalkersComponent implements OnInit {
    testimonials: TestimonialQuoteType[] = [];

    constructor(private readonly translate: TranslateService) {}

    ngOnInit() {
      this.testimonials = [
        {
          content: this.translate.instant('home.talkersPage.t1'),
          author: 'N',
          color: '#FF8B05'
        }, {
          content: this.translate.instant('home.talkersPage.t2'),
          author: 'S',
          color: '#8364ab'
        }, {
          content: this.translate.instant('home.talkersPage.t3'),
          author: 'M',
          color: '#bdabd4'
        }, {
          content: this.translate.instant('home.talkersPage.t4'),
          author: 'H',
          color: '#FF8B05'
        }, {
          content: this.translate.instant('home.talkersPage.t5'),
          author: 'N',
          color: '#8364ab'
        },
      ];
    }
}
